import { useCallback, useState } from "react"

export const useOnboardingTooltips = (): {
  tooltipsVisible: boolean
  dismissTooltips: () => void
} => {
  const [tooltipsVisible, setTooltipsVisible] = useState(true)
  const dismissTooltips = useCallback(() => setTooltipsVisible(false), [])
  return { tooltipsVisible, dismissTooltips }
}
